import { Validators } from '@angular/forms';

export const regionFilterForm = {
  Region: []
}

export const workOrderDetailsForm = {
  AddInfoCategories: [],
  ArchitectureId: [],
  AssignedEngineerName: [],
  CMEAreaId: ['', Validators.required],
  ErgoEngineer: [],
  GateId: ['', Validators.required],
  GateTargeted: ['', Validators.required],
  ME: ['', Validators.required],
  MELead: [],
  OtherStudyName: ['', Validators.maxLength(50)],
  PlantId: ['', Validators.required],
  ProgramDetailId: ['', Validators.required],
  ProgramId: [],
  RequestDate: [],
  Requestor: ['', Validators.required],
  RequiredDate: ['', Validators.required],
  SMT1Id: ['', Validators.required],
  SMT2Id: ['', Validators.required],
  SMT3Id: ['', Validators.required],
  StudyInstructions: ['', Validators.required],
  StudyNumber: [],
  StudyTitleId: ['', Validators.required],
  ToolingOperatorInterfaces: [],
  VELead: [],
  RequestorComments: [],
  VEComments: [],
  WorkOrderComments: [],
  Status: [],

  Id: [],
  ProjectId: [],
  ProjectVersion: [],
  StatusId: [],
  WorkOrderNumber: [],
};

export const additionalInfoForm = {
  Id: [],
  IsRequired: [],
  Description: [],
  CategoryDescription: ['', Validators.maxLength(255)],
  Type: [],
  File: []
};

export const deliverablesObjectivesForm = {
  Id: [],
  Objective: ['', Validators.maxLength(255)]
};

export const gaAddMultipleForm = {
  AddInfoCategories: [],
  ArchitectureId: [],
  ErgoEngineer: [],
  GateId: ['', Validators.required],
  GateTargeted: ['', Validators.required],
  MELead: [],
  PlantId: ['', Validators.required],
  ProgramDetailId: ['', Validators.required],
  ProgramId: [],
  RequestDate: [],
  RequiredDate: ['', Validators.required],
  StatusId: [],
  StudyInstructions: ['', Validators.required],
  StudyNumber: [],
  ToolingOperatorInterfaces: [],
  VELead: [],
};

export const gaWoSubmitReportForm = {
  ActualCompletionDate: [],
  ActualStartDate: [],
  AdditionalEmailIds: [],
  EmailNotes: [],
  HoursToComplete: [],
  HoursToSyncMath: [],
  Id: [],
  LoadClearanceIssues: [],
  LoadInterferenceIssues: [],
  NotificationList: [],
  NumOfMathIssues: [],
  PlannedCompletionDate: [],
  PTAClearanceViolations: [],
  PTAIntereferenceIssues: [],
  Status: [],
  StatusId: [],
  WorkOrderComments: []
};
